import { useLocalStore, useAsObservableSource } from 'mobx-react-lite';

import { isMentionAll } from '@gem/utils';

import Tasks from 'APP/Tasks';
import { ParticipantsPopup } from 'APP/main/PopupManager/Popups/ParticipantsPopup/ParticipantsPopup';
import Entities from 'STORE';

export default ({ nickname }) => {
  const source = useAsObservableSource({ nickname });

  const presenter = useLocalStore(() => ({
    get group() {
      return Entities.GroupsStore.activeGroup;
    },

    get isMentionAll() {
      return presenter.group?.canMentionAll && isMentionAll(source.nickname);
    },

    openMention() {
      Tasks.app.openPopup(ParticipantsPopup, { params: { groupId: presenter.group?.id } });
    },
  }));

  return presenter;
};
